import {
    Divider,
    Icon,
    IconButton,
    ListItemIcon,
    ListItemText,
    ListSubheader,
    Menu,
    MenuItem
} from "@mui/material";
import {useEffect, useRef, useState} from "react";
import {Link, useLocation} from "react-router-dom";
import {
    authRequired,
    canAccessAnyModule,
    canAccessFinanceira,
    canAccessFolha
} from "../../shared/keycloak";
import Logout from "./Logout";
import Status, {StatusMenuItem} from "./Status";
import {api} from "../../api/DpgeIntegracaoEsfingeApi";
import useFeedback from "../feedback/useFeedback";

function HeaderMenu() {
    const mounted = useRef(true);
    useEffect(
        () => () => {
            mounted.current = false;
        },
        []
    );
    const {showError} = useFeedback();
    const [verificando, setVerificando] = useState(false);
    const {pathname} = useLocation();
    const [anchorEl, setAnchorEl] = useState(null);
    const [statusOpen, setStatusOpen] = useState(false);
    const open = Boolean(anchorEl);
    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
        setAnchorEl(null);
    };
    const handleStatusOpen = () => {
        handleClose();
        setStatusOpen(true);
    };

    return (
        <>
            <IconButton
                aria-label="Abrir menu principal"
                sx={{
                    color: "white",
                    height: 40
                }}
                onClick={handleClick}
            >
                <Icon>menu</Icon>
            </IconButton>
            <Menu
                id="basic-menu"
                open={open}
                onClose={handleClose}
                anchorEl={anchorEl}
                anchorOrigin={{
                    vertical: "bottom",
                    horizontal: "right"
                }}
                transformOrigin={{
                    vertical: "top",
                    horizontal: "right"
                }}
                PaperProps={{
                    sx: {
                        width: 286,
                        mt: 0.75,
                        borderRadius: 2,
                        boxShadow: "0 10px 30px rgba(25, 45, 31, 0.18)"
                    }
                }}
                MenuListProps={{dense: true, sx: {py: 1}}}
            >
                {canAccessAnyModule() && (
                    <ListSubheader disableSticky>Acompanhamento</ListSubheader>
                )}
                {canAccessAnyModule() && (
                    <MenuLink
                        to="/"
                        icon="list_alt"
                        selected={pathname === "/"}
                        onClick={handleClose}
                    >
                        Ocorrências
                    </MenuLink>
                )}
                {canAccessAnyModule() && (
                    <MenuLink
                        to="/dashboard"
                        icon="dashboard"
                        selected={pathname === "/dashboard"}
                        onClick={handleClose}
                    >
                        Dashboard de envios
                    </MenuLink>
                )}
                {canAccessAnyModule() && <Divider sx={{my: 1}} />}
                {canAccessAnyModule() && (
                    <ListSubheader disableSticky>Operações</ListSubheader>
                )}
                {canAccessFolha() && (
                    <MenuLink
                        to="/integracao-folha"
                        icon="sync_alt"
                        selected={pathname === "/integracao-folha"}
                        onClick={handleClose}
                    >
                        Integração Folha
                    </MenuLink>
                )}
                {canAccessFinanceira() && (
                    <MenuLink
                        to="/integracao-financeira"
                        icon="account_balance"
                        selected={pathname === "/integracao-financeira"}
                        onClick={handleClose}
                    >
                        Integração Financeira
                    </MenuLink>
                )}
                {canAccessAnyModule() && (
                    <MenuLink
                        to="/servicos-gerais"
                        icon="manage_search"
                        selected={pathname === "/servicos-gerais"}
                        onClick={handleClose}
                    >
                        Serviços Gerais
                    </MenuLink>
                )}
                <Divider sx={{my: 1}} />
                <ListSubheader disableSticky>Sistema</ListSubheader>
                {authRequired && (
                    <MenuItem
                        disabled={verificando}
                        onClick={async () => {
                            setVerificando(true);
                            try {
                                await api.revalidateAccess();
                                if (mounted.current) handleClose();
                            } catch (error) {
                                if (mounted.current) showError(error);
                            } finally {
                                if (mounted.current) setVerificando(false);
                            }
                        }}
                    >
                        <ListItemIcon>
                            <Icon fontSize="small">refresh</Icon>
                        </ListItemIcon>
                        <ListItemText>
                            {verificando
                                ? "Verificando acesso…"
                                : "Verificar acesso"}
                        </ListItemText>
                    </MenuItem>
                )}
                <StatusMenuItem onClick={handleStatusOpen} />
                {authRequired && <Logout />}
            </Menu>
            <Status open={statusOpen} onClose={() => setStatusOpen(false)} />
        </>
    );
}

function MenuLink({to, icon, selected, onClick, children}) {
    return (
        <MenuItem
            component={Link}
            to={to}
            selected={selected}
            onClick={onClick}
            sx={{mx: 1, px: 1.5, borderRadius: 1.25}}
        >
            <ListItemIcon>
                <Icon fontSize="small" color={selected ? "primary" : "inherit"}>
                    {icon}
                </Icon>
            </ListItemIcon>
            <ListItemText
                primary={children}
                primaryTypographyProps={{fontWeight: selected ? 700 : 400}}
            />
        </MenuItem>
    );
}

export default HeaderMenu;
